import * as Sentry from "@sentry/react";
Sentry.init({
    dsn: process.env.PEEK_APP_SENTRY_DSN,
    enabled: process.env.PEEK_APP_ENVIRONMENT === "prod",
    environment: process.env.PEEK_APP_ENVIRONMENT,
    beforeSend(event) {
        var _a, _b, _c;
        const errorValue = (_c = (_b = (_a = event.exception) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.value;
        if (typeof errorValue === "string" && errorValue.includes("Object Not Found Matching Id")) {
            return null;
        }
        return event;
    },
});
Sentry.configureScope((scope) => {
    scope.setTag("application", "dashboard");
});
